module.exports = __webpack_public_path__ + "static/img/ditu.eb05ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ditu.png
// module id = MnRE
// module chunks = 1